import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type {
  IbhBearingPartsLightParams,
  IbhPartsLifetimeResponseDto,
  IbhPartsRequestDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import * as Sentry from '@sentry/nextjs';

export const fetchPartsLifetime = async (
  query: IbhBearingPartsLightParams,
  data: IbhPartsRequestDto
): Promise<IbhPartsLifetimeResponseDto> => {
  try {
    // The API client is shared across concurrent Next.js requests.
    const cancelToken = typeof window !== 'undefined' ? 'bearingPartsLifetime' : undefined;
    if (cancelToken) {
      ibhApiService.abortRequest(cancelToken);
    }
    const response = await ibhApiService.bearingPartsLifetime(query, { ...data }, { cancelToken });
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      contexts: {
        request: {
          query,
          data: { ...data },
        },
      },
      tags: {
        api_call: 'bearingPartsLifetime',
      },
      level: 'error',
    });
    throw new Error(`Cannot fetch parts lifetime for given data: ${JSON.stringify(data)}`);
  }
};
